import { Directive } from '@angular/core';
import { PropertyType } from 'src/app/models/enums/property-type';
import { ColumnDefinition } from '../../models/server/column-definition';
import { BaseDirective } from './base.directive';

@Directive({
    standalone: false
})
export abstract class TableHeaderBaseDirective extends BaseDirective {
    constructor() {
        super();
    }

    /**
     * Retourne une valeur indiquant si le type de saisie du filtre de la colonne est standard (texte ou nombre).
     * @param columnDef : Definition de la colonne.
     * @returns : true si le type de saisie du filtre de la colonne est standard (texte ou nombre); false autrement.
     */
    public isStandardInputColumn(columnDef: ColumnDefinition): boolean {
        return columnDef.type === PropertyType.Text;
    }

    /** Retourne une valeur indiquant si le type est liste */
    public isListInputColumn(columnDef: ColumnDefinition): boolean {
        return columnDef.type === PropertyType.List;
    }

    /**
     * Retourne une valeur indiquant si le type est enum
     * @param columnDef : Definition de la colonne.
     * @returns : true si le type de saisie du filtre de la colonne est enum; false autrement.
     * */
    public isEnumInputColumn(columnDef: ColumnDefinition): boolean {
        return columnDef.type === PropertyType.Enum;
    }

    /**
     * Retourne une valeur indiquant si le type de saisie du filtre de la colonne est de type date.
     * @param columnDef : Definition de la colonne.
     * @returns : true si le type de saisie du filtre de la colonne est de type date; false autrement.
     */
    public isDateInputColumn(columnDef: ColumnDefinition): boolean {
        return columnDef.type === PropertyType.Date;
    }

    /**
     * Retourne une valeur indiquant si le type de saisie du filtre de la colonne est de type date & heure.
     * @param columnDef : Definition de la colonne.
     * @returns : true si le type de saisie du filtre de la colonne est de type date & heure; false autrement.
     */
    public isDateAndTimeInputColumn(columnDef: ColumnDefinition): boolean {
        return columnDef.type === PropertyType.DateAndTime;
    }
}
